import { Component, Inject, OnInit } from "@angular/core";
import { OKTA_AUTH, OktaAuthStateService } from "@okta/okta-angular";
import OktaAuth, { AuthState } from "@okta/okta-auth-js";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "app-root",
  standalone: false,
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "Conversational Agents Dashboard";
  isAuthenticated$!: Observable<boolean>;
  userEmail$!: Observable<string | undefined>;

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private authStateService: OktaAuthStateService,
  ) {}

  ngOnInit(): void {
    this.isAuthenticated$ = this.authStateService.authState$.pipe(
      map((state: AuthState) => state?.isAuthenticated ?? false),
    );
    this.userEmail$ = this.authStateService.authState$.pipe(
      map(
        (state: AuthState) =>
          state?.idToken?.claims?.email as string | undefined,
      ),
    );
  }

  async logout(): Promise<void> {
    await this.oktaAuth.signOut();
  }
}
